import { TURKISH } from '../../../assets/images';
import { Section, TableOfContent } from '../../../typings/interfaces';
// Turkish
const TRSection: Section[] = [
  {
    name: '1: Referans ve Genel Bakış',
    subSections: [
      {
        name: 'Önsöz',
        page: 3,
      },
      {
        name: 'Amaç ve Saha Kılavuzu Uygulamaları',
        page: 4,
      },
      {
        name: 'Temel Tanımlar',
        page: 5,
      },
      {
        name: 'Kontrol Hiyerarşisi',
        page: 6,
      },
    ],
  },
  {
    name: '2: LIFEsavers (HAYAT Kurtarıcılar)',
    subSections: [
      {
        name: 'Motorlu Araç - Trafik Güvenliği',
        page: 9,
      },
      {
        name: 'Yüksekte Çalışma',
        page: 12,
      },
      {
        name: 'Motorlu Mobil Ekipman (MPE)',
        page: 18,
      },
      {
        name: 'Kilitleme ve Etiketleme / Enerji Yalıtımı',
        page: 22,
      },
      {
        name: 'Elektrik İşleri',
        page: 25,
      },
      {
        name: 'Kapalı Alanlar',
        page: 29,
      },
      {
        name: 'Yığın Malzemeler ve Depolama',
        page: 32,
      },
      {
        name: 'Vagon Güvenliği',
        page: 37,
      },
      {
        name: 'Kazı ve Hendek İşleri',
        page: 41,
      },
      {
        name: 'Kaldırma ve Sapanlama',
        page: 45,
      },
      {
        name: 'Tehlikeli Maddeler',
        page: 49,
      },
      {
        name: 'Sıcak Çalışma',
        page: 52,
      },
    ],
  },
  {
    name: '3: Ek Kaynaklar ve Araçlar',
    subSections: [
      {
        name: 'Suyun Üzerinde ve Etrafında Çalışma',
        page: 56,
      },
      {
        name: 'Düşürülen veya Düşen Nesneler',
        page: 59,
      },
      {
        name: 'Atmosferik Test/Gaz Testi',
        page: 61,
      },
      {
        name: 'Kimyasal Tehlikelerle İlgili İletişim',
        page: 65,
      },
    ],
  },
  {
    name: '4: Cargill İş Güvenliği Yönetimi Uygulamaları',
    subSections: [
      {
        name: 'Temel Terminoloji',
        page: 70,
      },
      {
        name: 'Ciddi Yaralanma ve Ölüm Olayı (SIF) Belirleme',
        page: 72,
      },
      {
        name: 'Ciddi Yaralanma ve Ölüm Olasılığını (SIFp) Sınıflandırma',
        page: 73,
      },
      {
        name: 'Otomatik SIF Belirleme Kriterleri Tablosu',
        page: 74,
      },
      {
        name: 'İnsan Performansı ve Örgütsel Performans (HOP)',
        page: 76,
      },
    ],
  },
];
const TRTableofContent: TableOfContent = {
  language: 'tr',
  sections: TRSection,
  label: 'İçindekiler',
  pdfLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/Cargill Field Safety Guide (tr_TR)_DIGITAL_CROPPED.pdf',
  hopPocket: 'HOP Cep Kılavuzu',
  hopPocketLink: 'https://en-pdfs-life-on-focus.dev.cglcloud.in/HOP pocket guide content 2021-09-08_Turkish.pdf',
  source: TURKISH,
};

export default TRTableofContent;
